// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductTile_root__2jvHc","image":"ProductTile_image__2dwph","name":"ProductTile_name__24OFi","label":"ProductTile_label__1XGVE","price":"ProductTile_price__880MG"};